import PanelContainer from './PanelContainer';

export default PanelContainer;
